import {
  FetchBaseQueryError,
  FetchBaseQueryMeta,
} from "@reduxjs/toolkit/dist/query";
import { QueryReturnValue } from "@reduxjs/toolkit/dist/query/baseQueryTypes";
import { removeHash } from "./hash";

export function defaultHeaders(headers: Headers, token?: string) {
  const defaultHeader: Headers = headers;

  if (token) {
    defaultHeader.set("Authorization", `Bearer ${token}`);
  }

  defaultHeader.set("ngrok-skip-browser-warning", "true");

  const productType = localStorage.getItem("product-type");
  const productId =
    (productType ? (removeHash(JSON.parse(productType)) as string) : 16) || 16;
  // const productId = 16;

  defaultHeader.set("productId", productId?.toString());

  return defaultHeader;
}

export async function defaultErrorMsg(
  result: QueryReturnValue<unknown, FetchBaseQueryError, FetchBaseQueryMeta>,
) {
  if (
    result.error &&
    result.error?.status === 401 &&
    (result?.error?.data as any)?.message === "Unauthorized"
  ) {
    // try {
    //   await keycloak.logout();
    //   localStorage.clear();
    // } catch (err) {
    //   console.error("Keycloak logout failed:", err);
    // }
  }
}
